<template src="./job.html"></template>

<script>
import JobService from 'Services/JobService';
import Pagination from 'Components/pagination/Pagination.vue';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      jobs: [],
      order_by_date: 0,
      search: '',
      type_job: '',
      address: '',
      i18n: 2,

      // pagination
      currentPage: 1,
      from: 0,
      to: 0,
      total: 0,
      perPage: 12,
      lastPage: 1,
      option: {
        useCurrent: false,
        format: 'YYYY-MM-DD',
      },
      isLoading: true,
    };
  },

  watch: {
    search() {
      this.listSearch();
    },
    order_by_date() {
      this.isLoading = true;
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      const params = {
        page: this.currentPage,
        per_page: this.perPage,
        search: this.search.toLowerCase(),
        type_job: this.type_job,
        address: this.address,
        order_by_date: this.order_by_date,
        i18n: this.i18n,
      };

      this.list(params);
    },
  },

  methods: {
    list(params) {
      JobService.listClient(params)
        .then((response) => {
          this.jobs = response.data.data;
          this.from = response.data.from;
          this.to = response.data.to;
          this.total = response.data.total;
          this.lastPage = response.data.last_page;
        })
        .catch(() => {});
    },
    listJobClient() {
      this.isLoading = true;
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      const params = {
        page: this.currentPage,
        limit: this.perPage,
        search: '',
        type_job: '',
        address: '',
        order_by_date: 0,
        i18n: this.i18n,
      };
      this.list(params);
      this.type_job = params.type_job;
      this.address = params.address;
      this.search = params.search;
    },
    listJobSearch(attibutes) {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      this.isLoading = true;
      const params = {
        page: this.currentPage,
        per_page: this.perPage,
        search: this.search,
        type_job: attibutes[0] !== null ? attibutes[0] : this.type_job,
        address: attibutes[1] !== null ? attibutes[1] : this.address,
        order_by_date: this.order_by_date,
        i18n: this.i18n,
      };

      this.list(params);
      this.type_job = params.type_job;
      this.address = params.address;
    },
    listSearch() {
      this.isLoading = true;
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      const params = {
        page: this.currentPage,
        per_page: this.perPage,
        search: this.search.toLowerCase(),
        type_job: this.type_job,
        address: this.address,
        order_by_date: this.order_by_date,
        i18n: this.i18n,
      };

      this.list(params);

      if (params.search === '') {
        this.type_job = this.type_job;
        this.address = this.address;
        this.search = this.search;
      }

      this.search = params.search;
    },
    onPageChange(page) {
      this.currentPage = page;
      this.listJobClient();
    },
  },
};
</script>
<style scoped>
.btn {
  font-size: 14px;
  color: #fff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: linear-gradient(50deg, #9e396ffa 0%, #3f2e2f52 100%);
  border-radius: 50px;
  border: none;
};
.btn:hover {
  color: rgba(62,46,46,1);
  background: linear-gradient(50deg, #9e396ffa 0%, #3f2e2f52 100%);
};
.btn:active {
  color: rgba(62,46,46,1);
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: linear-gradient(50deg, #9e396ffa 0%, #3f2e2f52 100%);
  border-radius: 50px;
  border: none;
}
</style>
